// extracted by mini-css-extract-plugin
export default {"contact":"contactus_contact__tXQHP","cardsContainer":"contactus_cardsContainer__qQvuq"};